<script setup lang="ts">
import { ref, onMounted } from 'vue'

import { isEmail } from '../../../utils/strings'
import { useSessionStore } from '../../../stores/session'

const props = defineProps<{
  onSuccess: () => void
}>()

const { resetPassword } = useSessionStore()

const preventSubmit = ref(true)
const showError = ref(false)
const error = ref<string | null>(null)
const email = ref('')
const processing = ref<boolean | null>(null)

onMounted(() => {
  // ssr: disable form submit until vue is initialized
  preventSubmit.value = false
})

const submit = async () => {
  error.value = null
  if (email.value.length === 0) {
    error.value = 'Bitte trage deine E-Mail-Adresse ein.'
    return
  }
  if (!isEmail(email.value)) {
    error.value = 'Bitte trage eine gültige E-Mail-Adresse ein.'
    return
  }

  error.value = null
  processing.value = true

  try {
    showError.value = false
    await resetPassword({ email: email.value })
    props.onSuccess()
  } catch (error_) {
    error.value = 'Bitte trage eine gültige E-Mail-Adresse ein.'
  }

  processing.value = null
}
</script>

<template>
  <form class="bx-form bx-form--pur bx-typo--form"
        autocomplete="on"
        @submit.prevent="submit">
    <h2 class="bx-typo--content-interline-h2">
      Passwort vergessen?
    </h2>
    <div class="bx-typo--content-continuous-text">
      <p>
        Trage hier deine E-Mail-Adresse ein, um einen Link für dein neues Passwort anzufordern.
      </p>
    </div>
    <div :class="{ 'bx-has-error': error }">
      <label for="reset_email"
             class="bx-form__label">
        E-Mail-Adresse
      </label>
      <input id="email"
             v-model="email"
             name="reset_email"
             type="text"
             autocomplete="email"
             placeholder="Deine E-Mail-Adresse"
             @focusout="error = null">
      <span v-if="error"
            class="bx-form__message bx-form__message--error">
        {{ error }}
      </span>
    </div>
    <div class="bx-form__item bx-form__item--centered">
      <button type="submit"
              class="bx-form__button"
              :disabled="processing || preventSubmit"
              :data-loader="processing">
        Link anfordern
      </button>
    </div>
  </form>
</template>
